import React, { Component, createRef } from 'react';
import * as Constants from '../../common/Global/constants';
import SpinnerLoader from 'react-loader-spinner';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import { encryptPassword, getThemeSettingsVariables, handleTokenExpiry, importPublicKey, isJsonString } from '../../common/Global/commonFunctions';
import AlertDialog from '../../common/AlertDialog';
import CryptoJS from "crypto-js";
import { connect } from "react-redux";
import { loginSuccess, auditeeLoginSuccess } from "../../../reducers/authSlice";
import { store } from '../../../redux/store';

let themeSettings = getThemeSettingsVariables();
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginEmail:"",
            loginPassword:"",
            errors:[],
            formSubmitted:false,

            showLogin:true,
            showForgotPassword:false,
            showAuditeeLogin:false,
            showAuditeeOTPScreen:false,
            forgotEmail:"",
            forgotErrors:[],

            auditeeEmail:"",
            auditeeLoginErrors:[],

            loggedInUserId:'',
            loggedInAccessToken:'',
            loggedInFirstName:'',
            loggedInLastName:'',
            loggedInEmail:'',
            loggedInPhoneNo:'',
            loggedInProfilePic:'',

            showOfflineModePopup: false,
            showOfflineDataLostPopup: false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            otp: new Array(6).fill(""),
            wrongOtpAttempts: 0,
        }
        this.inputs = Array(6)
            .fill(null)
            .map(() => createRef());
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount()
    {
        const state = store.getState();
        const userDetailStr = state.auth?.loggedInUserDetails;
        if(userDetailStr)
        {
            if(state.auth?.firstLogin+"" === "0"){
                this.props.history.push('/dashboard');
            }else if(userDetailStr?.userType === "ae"){
                this.props.history.push('/auditeedraftassignmentreport');
            }else{
                this.props.history.push('/');
            }
            
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.checkLogin();
        }
    }

    checkLogin = async (isMandatory = false) => {
        this.setState({
            formSubmitted:true,
        });
        
        const { loginEmail, loginPassword } = this.state;
        
        if(!this.validateCheckLoginForm()){
            // 1. Fetch public key from server
            const keyResponse = await fetch(Constants.PublicKeyUrl);
            const { publicKey: publicKeyPem } = await keyResponse.json();
            
            // 2. Import public key into Web Crypto
            const publicKey = await importPublicKey(publicKeyPem);
    
            // 3. Encrypt password
            const encryptedPassword = await encryptPassword(publicKey, loginPassword);

            const body = { email: loginEmail, password: encryptedPassword , loginFrom: "Web" };
            if (isMandatory) {
                body.isMandatory = "Y";
            }

            fetch(Constants.CheckLogin,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(body),
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(data.responseCode === 0){
                    this.setState({ 
                        loggedInUserId: data.data.userId,
                        loggedInEmail: data.data.email,
                        loggedInPhoneNo: data.data.phoneNo,
                        loggedInFirstName:data.data.firstName,
                        loggedInLastName:data.data.lastName,
                        loggedInAccessToken:data.data.accessToken,
                        loggedInProfilePic:data.data.profilePic,
                        themeSettings:data.data.themeSettings,
                        firstLogin:data.data.firstLogin,
                        clientSubscriptions:data.data?.clientSubscriptions ?? []
                    },()=>{
                        this.saveLocalStorage(this.state.loggedInUserId,this.state.loggedInEmail,
                            this.state.loggedInProfilePic,this.state.loggedInPhoneNo,this.state.loggedInFirstName,
                            this.state.loggedInLastName,this.state.loggedInAccessToken,this.state.themeSettings,
                            this.state.firstLogin, this.state.clientSubscriptions);
                        if(data.data.role === "SuperAdmin"){
                            this.props.history.push('/listclients');
                        }else{
                            if(this.state.firstLogin === 0){
                                this.props.history.push('/dashboard');
                                
                            }else if(this.state.firstLogin === 1){
                                //goto change password screen
                                this.props.history.push('/changepassword');
                            }
                            
                        }
                    });
                }
                else if (data.responseCode === 240)
                {
                    this.setState({
                        formSubmitted: false,
                        showOfflineModePopup: true,
                    });
                }
                else
                {
                    this.setState({
                        formSubmitted:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
        else
        {
            setTimeout(function(){
                this.setState({errors:[]});
            }.bind(this),Constants.WRNG_MSG_TIMEOUT);

            this.setState({
                formSubmitted:false,
            });
        }
    }

    saveAuditeeLocalStorage = (loggedInUserEmail,loggedInPhoneNo,
        loggedInFirstName,loggedInLastName,loggedInAccessToken,userType,companyLogo) =>{
        let parameters = {
            loggedInUserEmail:loggedInUserEmail,
            loggedInPhoneNo:loggedInPhoneNo,
            loggedInFirstName:loggedInFirstName,
            loggedInLastName:loggedInLastName,
            loggedInAccessToken:loggedInAccessToken,
            userType:userType,
            companyLogo:companyLogo || ""
        }
        const dynamicKey = CryptoJS.lib.WordArray.random(16).toString();

        this.props.auditeeLoginSuccess({
            encryptionKey: dynamicKey,
            loggedInUserDetails: parameters,
        });
    }

    saveLocalStorage = (loggedInUserId,loggedInUserEmail,loggedInProPic,loggedInPhoneNo,
        loggedInFirstName,loggedInLastName,loggedInAccessToken,themeSettings,firstLogin, clientSubscriptions) =>{
        let parameters = {
            loggedInUserId:loggedInUserId,
            loggedInUserEmail:loggedInUserEmail,
            loggedInProPic:loggedInProPic,
            loggedInPhoneNo:loggedInPhoneNo,
            loggedInFirstName:loggedInFirstName,
            loggedInLastName:loggedInLastName,
            loggedInAccessToken:loggedInAccessToken,
        };

        const dynamicKey = CryptoJS.lib.WordArray.random(16).toString();

        let otherUserDetails = {
            processMastersInfoFlag: true,
            functionMastersInfoFlag: true,
            industryMastersInfoFlag: true
        }
        const clientSubscription = isJsonString(clientSubscriptions) ? JSON.parse(clientSubscriptions) : clientSubscriptions;
        this.props.loginSuccess({
            encryptionKey: dynamicKey,
            loggedInUserDetails: parameters,
            otherUserDetails,
            firstLogin,
            clientSubscriptions: clientSubscription ?? [],
            themeSettingsData: themeSettings
        });
    }

    validateCheckLoginForm = () => {
        var error_flag = false;
        let errors = {};

        if(this.state.loginEmail === "")
        {
            error_flag = true;
            errors['loginEmail'] = "Please enter email";
        }

        if(this.state.loginEmail !== "")
        {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if(!pattern.test(this.state.loginEmail)) {
                error_flag = true;
                errors["loginEmail"] = "Please enter valid email";
            }
        }
        let password = this.state.loginPassword;
        if(password === "")
        {
            error_flag = true;
            errors['loginPassword'] = "Please enter password";
        }
        this.setState({
            errors: errors
        });

        return error_flag;
    }

    auditeeLoginLayout = () => {
        this.setState({
            showAuditeeLogin:true,
            showForgotPassword:false,
            showLogin:false
        })
    }

    showForgotPasswordLayout = () => {
        this.setState({
            showForgotPassword:true,
            showLogin:false,
            showAuditeeLogin:false
        })
    }
    
    showLoginLayout = () => {
        this.setState({
            showForgotPassword:false,
            showLogin:true,
            showAuditeeLogin:false
        })
    }

    auditeeLogin = () => {
        this.setState({
            formSubmitted:true,
        });

        var error_flag = false;
        let errors = {};

        if(this.state.auditeeEmail === ""){
            error_flag = true;
            errors['auditeeEmail'] = "Please enter email";
        }

        if(this.state.auditeeEmail != ""){
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if(!pattern.test(this.state.auditeeEmail)) {
                error_flag = true;
                errors["auditeeEmail"] = "Please enter valid email";
            }
        }

        if (!error_flag){
            fetch(Constants.LoginAuditorRequestOTP,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({email:this.state.auditeeEmail})
            })
            .then(response => { return response.json(); } )
            .then(data => {
                if(data.responseCode === 3){
                    // let otp = data.otp;
                    this.setState({
                        showAuditeeLogin:false,
                        showAuditeeOTPScreen:true,
                        formSubmitted:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                        wrongOtpAttempts: 0,
                        otp: new Array(6).fill(""),
                    });
                }else{
                    this.setState({
                        formSubmitted:false,
                        auditeeEmail:"",
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }else{
            this.setState({
                auditeeLoginErrors: errors,
                formSubmitted:false,
            });

            setTimeout(function(){
                this.setState({auditeeLoginErrors:[]});
            }.bind(this),Constants.WRNG_MSG_TIMEOUT);

           this.setState({
                formSubmitted:false,
            });
        }
    }

    verifyOTP = () => {
        this.setState({
            formSubmitted:true,
        });
        
        var error_flag = false;
        let errors = {};
        
        const otpValue = this.state.otp.join("");
        if(this.state.auditeeEmail === ""){
            error_flag = true;
            errors['auditeeOtp'] = "Please enter otp";
        }

        if (otpValue.length !== 6) {
            this.setState({
                auditeeLoginErrors: {
                    inValidOtp: "Please enter valid OTP"
                },
                formSubmitted:false,
            });
            return;
        }
        if (!error_flag){
            fetch(Constants.LoginAuditorVerifyOTP,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:this.state.auditeeEmail,
                    otp:otpValue
                })
            })
            .then(response => { return response.json(); } )
            .then(data => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        loggedInEmail: data.data.email,
                        loggedInPhoneNo: data.data.phoneNo,
                        loggedInFirstName:data.data.firstName,
                        loggedInLastName:data.data.lastName,
                        loggedInAccessToken:data.data.accessToken,
                        userType:data.data.userType,
                        companyLogo: data.data.companyDetails?.companyLogo || "",
                    },()=>{
                        this.saveAuditeeLocalStorage(this.state.loggedInEmail,
                            this.state.loggedInPhoneNo,this.state.loggedInFirstName,
                            this.state.loggedInLastName,this.state.loggedInAccessToken,
                            this.state.userType,this.state.companyLogo);
                        if(this.state.userType === "ae"){
                            this.props.history.push('/auditeedraftassignmentreport');
                        }
                    });
                    this.setState({
                        formSubmitted:false,
                        otp: new Array(6).fill(""),
                        // showAlertDialogInfo:true,
                        // alertDialogMessageInfo:data.responseMessage
                    });
                }else{
                    const newAttempts = this.state.wrongOtpAttempts + 1;
                    if(newAttempts >= 3){
                        this.setState({
                            formSubmitted: false,
                            otp: new Array(6).fill(""),
                            wrongOtpAttempts: 0,
                            auditeeLoginErrors: {},
                            auditeeEmail: "",
                            showAuditeeOTPScreen: false,
                            showAuditeeLogin: true,
                        });
                    }else{
                        this.setState({
                            formSubmitted: false,
                            otp: new Array(6).fill(""),
                            wrongOtpAttempts: newAttempts,
                            auditeeLoginErrors: {
                                inValidOtp: data.responseMessage || "Invalid OTP. Please try again.",
                            },
                        });
                        setTimeout(() => {
                            this.setState({ auditeeLoginErrors: {} });
                        }, Constants.WRNG_MSG_TIMEOUT);
                    }
                }
            });
        }
    }

    forgotPassword = () => {
        this.setState({
            formSubmitted:true,
        });

        var error_flag = false;
        let errors = {};

        if(this.state.forgotEmail === "")
        {
            error_flag = true;
            errors['forgotEmail'] = "Please enter email";
        }

        if(this.state.forgotEmail != "")
        {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if(!pattern.test(this.state.forgotEmail)) {
                error_flag = true;
                errors["forgotEmail"] = "Please enter valid email";
            }
        }

        if (!error_flag)
        {
            fetch(Constants.ForgotPassword,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams({email:this.state.forgotEmail})
                })
                .then(response => { return response.json(); } )
                .then(data =>
                {
                    this.setState({
                        formSubmitted:false,
                        forgotEmail:"",
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                });

        }else{
            this.setState({
                forgotErrors: errors
            });

            setTimeout(function(){
                this.setState({forgotErrors:[]});
            }.bind(this),Constants.WRNG_MSG_TIMEOUT);

           this.setState({
                formSubmitted:false,
            });
        }
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    hideOfflineModePopup = (isOk = false) => {
        this.setState({
            showOfflineModePopup: false,
        }, () => {
            if (isOk) {
                this.setState({
                    showOfflineDataLostPopup: true,
                });
            }
            else {
                this.setState({
                    loginEmail: "",
                    loginPassword: "",
                });
            }
        });
    }

    hideOfflineDataLostPopup = (isProceed = false) => {
        this.setState({
            showOfflineDataLostPopup: false,
        }, () => {
            if (isProceed) {
                this.checkLogin(true);
            }
            else {
                this.setState({
                    loginEmail: "",
                    loginPassword: "",
                });
            }
        });
    }

    handleOtpChange = (e, index) => {
        const value = e.target.value;

        if (!/^\d*$/.test(value)) return;

        let otp = [...this.state.otp];
        otp[index] = value.slice(-1);

        this.setState({ otp }, () => {
            if (value && index < this.inputs.length - 1) {
                this.inputs[index + 1].current.focus();
            }
        });
    };

    handleKeyDown = (e, index) => {
        const { otp } = this.state;

        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                this.inputs[index - 1].current.focus();
            }
        }
    };

    handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text").slice(0, 6);

        if (!/^\d+$/.test(pastedData)) return;

        let otp = [...this.state.otp];
        pastedData.split("").forEach((num, i) => {
            otp[i] = num;
        });

        this.setState({ otp }, () => {
            this.inputs[pastedData.length - 1].current.focus();
        });
    };

    render(){
        return(
            <Router>
                <main className="login-bg">
                    <div className="login-wrapper">
                        <div className="login-wrapper-col">

                            {
                                this.state.showLogin &&
                                <div className="login-form">
                                    <div className="login-form-logo">
                                        <img src="assets/images/sameeksha.png" />
                                        <h6>Login</h6>
                                    </div>

                                    <div className="login-form-col">
                                        <div className="login-input-group">
                                            <div className="login-field">
                                                <span className="material-icons">person</span>
                                                <input autofocus="true" type="text" placeholder="Email" onChange={this.handleChange}
                                                name="loginEmail" value={this.state.loginEmail}/>
                                            </div>
                                            <span className="errorspan-login">{this.state.errors.loginEmail}</span>
                                        </div>
                                
                                    <div className="login-input-group">
                                        <div className="login-field">
                                            <span className="material-icons">lock</span>
                                            <input type="password" placeholder="Password" onChange={this.handleChange}
                                            onKeyPress={this.onEnterBtnPress}
                                            name="loginPassword" value={this.state.loginPassword}/>
                                            <div className="tool tooltip-bg" data-title="Minimum 8 characters, at least one uppercase, one lowercase, one number & one special character">
                                                <span className="material-icons" style={{verticalAlign:'middle'}}>info</span>
                                            </div>
                                        </div>

                                        <span className="errorspan-login">{this.state.errors.loginPassword}</span>
                                    </div>

                                    <div style={{display:"none"}} className="login-input-group">
                                        <div className="login-remember">
                                            <span className="material-icons">crop_square</span>
                                            <p>Remember Me</p>
                                        </div>
                                    </div>

                                    <div className="login-input-group">
                                        <div className="login-button">
                                            <button 
                                                type="button" 
                                                disabled={this.state.formSubmitted} 
                                                onClick={() => this.checkLogin()}>
                                                Login
                                                {
                                                    this.state.formSubmitted &&
                                                    <SpinnerLoader style={{ marginLeft:10 }} 
                                                    type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                }
                                            </button>
                                        </div>
                                    </div>
                                    <div className="login-input-group m-b-0">
                                        <div className="forgot-password-text">
                                            <p>Forgot Password? <a onClick={this.showForgotPasswordLayout} href="javascript:void(0);">Click Here</a></p>
                                        </div>
                                    </div>
                                    <div className="login-input-group m-b-0">
                                        <div className="forgot-password-text">
                                            <p style={{lineHeight:0}}><a style={{fontSize:16}} onClick={this.auditeeLoginLayout} href="javascript:void(0);">Client Login</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.showForgotPassword && 
                            <div className="login-form">
                                <div className="login-form-logo">
                                    <img src="assets/images/sameeksha.png" />
                                    <h6>Forgot Password</h6>
                                </div>

                                <div className="login-form-col">
                                    <div className="login-input-group">
                                        <div className="login-field">
                                            <span className="material-icons">person</span>
                                            <input type="text" placeholder="Enter your email" onChange={this.handleChange}
                                            name="forgotEmail" value={this.state.forgotEmail}/>
                                        </div>
                                        <span className="errorspan-login">{this.state.forgotErrors.forgotEmail}</span>
                                    </div>

                                    <div className="login-input-group">
                                        <div className="login-button">
                                            <button 
                                                type="button" 
                                                disabled={this.state.formSubmitted} 
                                                onClick={this.forgotPassword}>
                                                Submit
                                                {
                                                    this.state.formSubmitted &&
                                                    <SpinnerLoader style={{ marginLeft:10 }} 
                                                    type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                }
                                            </button>
                                        </div>
                                        <span className="errorspan-login">{this.state.forgotErrors.invalidEmail}</span>
                                    </div>
                                    <div className="login-input-group m-b-0">
                                        <div className="forgot-password-text">
                                            <p>Click here to <a onClick={this.showLoginLayout} href="javascript:void(0);">Login</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.showAuditeeLogin && 
                            <div className="login-form">
                                <div className="login-form-logo">
                                    <img src="assets/images/sameeksha.png" />
                                    <h6>Client Login</h6>
                                </div>

                                <div className="login-form-col">
                                    <div className="login-input-group">
                                        <div className="login-field">
                                            <span className="material-icons">person</span>
                                            <input type="text" placeholder="Enter your email" onChange={this.handleChange}
                                            name="auditeeEmail" value={this.state.auditeeEmail}/>
                                        </div>
                                        <span className="errorspan-login">{this.state.auditeeLoginErrors.auditeeEmail}</span>
                                    </div>

                                    <div className="login-input-group">
                                        <div className="login-button">
                                            <button 
                                                type="button" 
                                                disabled={this.state.formSubmitted} 
                                                onClick={this.auditeeLogin}>
                                                Submit
                                                {
                                                    this.state.formSubmitted &&
                                                    <SpinnerLoader style={{ marginLeft:10 }} 
                                                    type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                }
                                            </button>
                                        </div>
                                        <span className="errorspan-login">{this.state.auditeeLoginErrors.invalidEmail}</span>
                                    </div>
                                    <div className="login-input-group m-b-0">
                                        <div className="forgot-password-text">
                                            <p>Click here to <a onClick={this.showLoginLayout} href="javascript:void(0);">Login</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.showAuditeeOTPScreen && 
                            <div className="login-form">
                                <div className="login-form-logo">
                                    <img src="assets/images/sameeksha.png" />
                                    <h6>Enter OTP Code</h6>
                                </div>

                                <div className="login-form-col">
                                    <div className="login-input-group">
                                        <div className='text-center'>
                                            <p style={{fontSize:12, color:"#fff"}}>Please enter the 6-digit code sent to your email.</p>
                                            {this.state.otp.map((value, index) => (
                                                <input
                                                    key={index}
                                                    ref={this.inputs[index]}
                                                    type="tel"
                                                    inputMode="numeric"
                                                    maxLength="1"
                                                    value={value}
                                                    onChange={(e) => this.handleOtpChange(e, index)}
                                                    onKeyDown={(e) => this.handleKeyDown(e, index)}
                                                    onPaste={this.handlePaste}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        fontSize: "22px",
                                                        textAlign: "center",
                                                        borderRadius: "6px",
                                                        marginRight: "10px",
                                                        border: "1px solid #ccc",
                                                        outline: "none"
                                                    }}
                                                    onFocus={(e) =>
                                                        (e.target.style.border = "2px solid #000000")
                                                    }
                                                    onBlur={(e) =>
                                                        (e.target.style.border = "2px solid #ccc")
                                                    }
                                                />
                                            ))}
                                        </div>
                                        {/* <span className="errorspan-login">{this.state.auditeeLoginErrors.auditeeEmail}</span> */}
                                    </div>

                                    <div className="login-input-group">
                                        <div className="login-button">
                                            <button 
                                                type="button" 
                                                disabled={this.state.formSubmitted} 
                                                onClick={this.verifyOTP}>
                                                Verify OTP
                                                {
                                                    this.state.formSubmitted &&
                                                    <SpinnerLoader style={{ marginLeft:10 }} 
                                                    type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                }
                                            </button>
                                        </div>
                                        <span className="errorspan-login">{this.state.auditeeLoginErrors.inValidOtp}</span>
                                    </div>
                                    <div className="login-input-group m-b-0">
                                        <div className="forgot-password-text">
                                            <p style={{lineHeight:0}}><a onClick={this.auditeeLogin} href="javascript:void(0);">Resend OTP</a></p>
                                        </div>
                                        <div className="forgot-password-text">
                                            <p>Click here to <a onClick={this.showLoginLayout} href="javascript:void(0);">Login</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                            <div className="login-menu">
                                <ul>
                                    <li><a target="_blank" href="https://www.sarvinfo.com/">Home</a></li>
                                    <li><a target="_blank" href="https://www.sarvinfo.com/privacy-policy/">Privacy Policy</a></li>
                                    <li><a target="_blank" href="https://www.sarvinfo.com/contact-us/">Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <AlertDialog
                        showAlertDialog={this.state.showOfflineModePopup}
                        handleAlertDialogClose={() => this.hideOfflineModePopup()}
                        type={Constants.ALERT_TYPE_INFO}
                        alertDialogMessage={"You were last working on offline mode on your mobile. Data will be lost, if you proceed with web mode."}
                        proceedBtnClick={() => this.hideOfflineModePopup(true)}
                        proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                        themeSettings={themeSettings}
                    />
                    <AlertDialog
                        showAlertDialog={this.state.showOfflineDataLostPopup}
                        handleAlertDialogClose={() => this.hideOfflineDataLostPopup()}
                        type={Constants.ALERT_TYPE_INFO}
                        alertDialogMessage={"Are you sure, you want to proceed with login? Offline data will get deleted and cannot be recovered."}
                        proceedBtnClick={() => this.hideOfflineDataLostPopup(true)}
                        proceedBtnLabel={Constants.ALERT_TYPE_PROCEED_LABEL}
                        themeSettings={themeSettings}
                    />
                    <AlertDialog 
                        showAlertDialog={this.state.showAlertDialogInfo}
                        handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                        type={Constants.ALERT_TYPE_ALERT}
                        alertDialogMessage={this.state.alertDialogMessageInfo}
                        proceedBtnClick={this.handleAlertDialogCloseInfo}
                        proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                        themeSettings={themeSettings}
                    />
                </main>
            </Router>
        );
    }
}

export default connect(null, { loginSuccess, auditeeLoginSuccess })(Login);